<template>
  <div v-if="lines.length" class="rounded-lg border bg-card shadow-sm">
    <div class="border-b px-4 py-2.5">
      <h3 class="text-sm font-semibold">Ligne{{ lines.length > 1 ? "s" : "" }} téléphonique{{ lines.length > 1 ? "s" : "" }} associée{{ lines.length > 1 ? "s" : "" }}</h3>
    </div>
    <div class="divide-y">
      <router-link
        v-for="l in lines"
        :key="l.id"
        to="/inventory"
        class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-accent/50"
      >
        <span class="font-mono">{{ l.number }}</span>
        <span class="min-w-0 flex-1 truncate text-xs text-muted-foreground">
          <span v-if="l.type">{{ l.type }} · </span>
          <span v-if="l.user">{{ l.user.name || l.user.email }}</span>
          <span v-else>non attribuée</span>
        </span>
        <span class="inline-block h-2 w-2 shrink-0 rounded-full" :class="l.active ? 'bg-emerald-500' : 'bg-slate-300'"></span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { usePhoneLineService } from "@/composables/phoneLineService";

export default {
  name: "PhoneLineInvoicePanel",
  props: {
    invoiceId: { type: [String, Number], required: true },
  },
  setup() {
    return { phone: usePhoneLineService() };
  },
  data() {
    return { lines: [] };
  },
  watch: {
    invoiceId() {
      this.load();
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.invoiceId) return;
      this.lines = await this.phone.byInvoice(this.invoiceId);
    },
  },
};
</script>
